import {AppAction} from '../../../appActions';
import {AnalyticsPanelFiltersActionsEnum} from './analyticsPanelFiltersActions';
import {AnalyticsPanelFiltersState, DEFAULT_FILTERS_STATE} from './analyticsPanelFiltersState';

/*
 * Analytics filters panel.
 */

export function analyticsPanelFiltersReducer(
  state: AnalyticsPanelFiltersState,
  action: AppAction,
): AnalyticsPanelFiltersState {
  switch (action.type) {
    case AnalyticsPanelFiltersActionsEnum.UPDATE_FILTERS:
      return {
        ...state,
        ...action.payload,
      };

    default:
      return state;
  }
}

export function makeAnalyticsPanelFiltersState(): AnalyticsPanelFiltersState {
  return DEFAULT_FILTERS_STATE;
}
